

























import { Blog } from '@/resource/blog/blog.model';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class BlogShare extends Vue {
  @Prop()
  blog: Blog;

  socialMedias = [
    {
      network: 'facebook',
      icon: 'ic_facebook_bg_black',
    },
    {
      network: 'linkedin',
      icon: 'ic_linkedin_bg_black',
    },
    {
      network: 'twitter',
      icon: 'ic_twitter_bg_black',
    },
  ];

  get currentUrl() {
    return 'https://mysoalan.com' + this.$router.currentRoute.fullPath;
  }

  iconUrl(icon: string) {
    return require('@/assets/icon/' + icon + '.svg');
  }

  copyUrlToClipboard() {
    this.$sendMpEvent({ event: this.$mp_value.BlogShare });
    this.$copyText(this.currentUrl);
    this.$toasted.global.mainToast({
      message: 'Blog link copied!',
    });
  }

  trackEvent() {
    this.$sendMpEvent({ event: this.$mp_value.BlogShare });
  }
}
